module.exports = __webpack_public_path__ + "img/3.af36e378.png";